import { render, staticRenderFns } from "./FundingProjectsContracts.vue?vue&type=template&id=3c381060&"
import script from "./FundingProjectsContracts.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports